var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"container bg-light text-center pt-80"},[_c('div',{staticClass:"d-block text-center"},[_c('div',[_c('h1',[_vm._v("400")]),_c('p',{staticClass:"text-dark w-100 fs-18"},[_vm._v("404 Not Found")]),_c('div',{staticClass:"text-center mt-20"})])])])])
}]

export { render, staticRenderFns }